import React from 'react';
import { Link } from 'react-router-dom';
import "./projectFile.css";

const ProjectFileComponent = ({ title, summary, id, project }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      month: 'short', 
      day: 'numeric', 
      year: 'numeric' 
    });
  };

  return (
    <article className="project-card">
      <header className="project-header">
        <div className="title-row">
          <Link
            to={`/projects/${id}`}
            state={{ project: project || { summary, title, id } }}
            className="project-title"
          >
            {title}
          </Link>
          {project?.featured && <span className="star">⋆</span>}
        </div>
        
        {project?.date && (
          <time className="project-date">
            {formatDate(project.date)}
          </time>
        )}
      </header>

      <p className="project-summary">{summary}</p>

      {project?.tags && (
        <footer className="project-tags">
          {project.tags.map((tag, index) => (
            <span key={tag}>
              {index > 0 && ' · '}
              {tag}
            </span>
          ))}
        </footer>
      )}

      {project?.links && (
        <div className="project-links">
          {project.links.github && (
            <a 
              href={project.links.github} 
              target="_blank" 
              rel="noopener noreferrer"
              onClick={(e) => e.stopPropagation()}
            >
              github
            </a>
          )}
          {project.links.live && (
            <a 
              href={project.links.live} 
              target="_blank" 
              rel="noopener noreferrer"
              onClick={(e) => e.stopPropagation()}
            >
              live
            </a>
          )}
          {project.links.paper && (
            <a 
              href={project.links.paper} 
              target="_blank" 
              rel="noopener noreferrer"
              onClick={(e) => e.stopPropagation()}
            >
              paper
            </a>
          )}
        </div>
      )}
    </article>
  );
};

export default ProjectFileComponent;